var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('qvoFootnote',{attrs:{"appLogoFileName":"ARIA-full.svg","appReleaseNotesPath":"https://confluence.quavo.com/display/ARIA/ARIA+"}})}
var staticRenderFns = []

export { render, staticRenderFns }